export enum ConversationView {
  conversations = 'conversations',
  activities = 'activities',
}
